import React from 'react';
import { useRowHighlight } from '../hooks/useRowHighlight';
import './HighlightedRowList.css';

// Wraps the container + sliding-highlight-box boilerplate every `PreviewRow`
// list on Home needs — each section previously called useRowHighlight()
// itself and repeated this same container/highlight-div JSX verbatim
// (Experience, Projects, Side Projects). `children` is a render function
// receiving the highlight object, so callers still wire
// onMouseEnter/onMouseLeave onto their own PreviewRows explicitly (kept
// visible/explicit here rather than auto-injected via cloneElement, so the
// full set of props passed to each PreviewRow stays easy to find/read).
const HighlightedRowList = ({ className = '', children }) => {
  const highlight = useRowHighlight();

  return (
    <div
      className={`preview-rows preview-rows--condensed${className ? ` ${className}` : ''}`}
      ref={highlight.containerRef}
    >
      <div
        ref={highlight.highlightRef}
        className="preview-rows-highlight"
        style={{
          height: highlight.boxStyle.height || '0px',
          transform: highlight.boxStyle.transform || 'translateY(0)',
          opacity: highlight.boxStyle.opacity || 0,
        }}
      />
      {children(highlight)}
    </div>
  );
};

export default HighlightedRowList;
